import React from 'react';
import { Protocol } from '../data/clinicalData';
interface ProtocolResultProps {
  protocol: Protocol;
}
export function ProtocolResult({
  protocol
}: ProtocolResultProps) {
  return <div className="animate-fade" data-id="element-140">
      <div className="bg-gradient-to-br from-bg3 to-bg2 py-4 px-4 md:py-5 md:px-6 flex flex-col gap-3 sm:flex-row sm:items-center sm:gap-4 border-b border-border" data-id="element-141">
        <div className="font-serif text-[2rem] md:text-[2.8rem] font-bold text-teal leading-none min-w-[50px] md:min-w-[70px] text-center sm:text-left" data-id="element-142">
          {protocol.abbr}
        </div>
        <div className="flex-1 min-w-0" data-id="element-143">
          <div className="text-[1.15rem] md:text-[1.5rem] font-bold text-ink mb-1 md:mb-1.5" data-id="element-144">
            {protocol.title}
          </div>
          <div className="text-[0.85rem] md:text-[0.95rem] text-ink3 leading-relaxed" data-id="element-145">
            Affected: {protocol.sick}
          </div>
        </div>
        <div className="flex gap-2 shrink-0 items-start" data-id="element-146">
          <span className="text-[0.7rem] font-extrabold tracking-[0.08em] uppercase bg-gold-d text-white py-1.5 px-3 rounded-lg" data-id="element-147">
            {protocol.badge}
          </span>
        </div>
      </div>

      <div className="py-4 px-4 pb-5 md:py-5 md:px-6 md:pb-6" data-id="element-148">
        <div className="bg-amber-p border border-amber border-l-[5px] rounded-r-lg rounded-l-sm py-3 px-4 md:py-4 md:px-5 mt-4 md:mt-6 text-[0.85rem] md:text-[0.95rem] text-[#b07d00] leading-relaxed" data-id="element-149">
          <strong className="block text-[0.75rem] md:text-[0.8rem] tracking-[0.08em] uppercase mb-1 md:mb-1.5 text-amber" data-id="element-150">
            Clinical Theory & Notes
          </strong>
          {protocol.theory}
        </div>

        <div className="mt-5 md:mt-6" data-id="element-151">
          <div className="font-sans text-[0.8rem] font-extrabold tracking-[0.1em] uppercase text-teal mb-2 flex items-center gap-2 after:content-[''] after:flex-1 after:h-px after:bg-border" data-id="element-152">
            Acupuncture 3: Point Selection
          </div>

          {protocol.sides.map((side, i) => <div key={i} className="flex items-start gap-3 md:gap-4 py-3 md:py-4 border-b border-bg3 last:border-b-0" data-id="element-153">
              <div className="w-[30px] h-[30px] md:w-[34px] md:h-[34px] rounded-full bg-teal-p text-teal border border-teal/30 flex items-center justify-center text-[0.8rem] md:text-[0.9rem] font-extrabold shrink-0 mt-0.5" data-id="element-154">
                {i + 1}
              </div>
              <div className="flex-1 min-w-0" data-id="element-155">
                <div className="text-[0.95rem] md:text-[1.1rem] font-bold text-ink mb-1.5 md:mb-2" data-id="element-156">
                  {side.side} Placement
                </div>
                <div className="flex flex-wrap gap-1.5 md:gap-2 mt-1.5 md:mt-2" data-id="element-157">
                  {side.points.map((pt, j) => {
                let pillClass = '';
                if (side.class === 'sp1') {
                  pillClass = 'bg-amber-p text-[#d08c00] border-amber/30';
                } else if (side.class === 'sp2') {
                  pillClass = 'bg-teal-p text-teal-l border-teal-l/30';
                } else if (side.class === 'sp3') {
                  pillClass = 'bg-red-p text-red border-red/30';
                }
                return <span key={j} className={`font-mono text-[0.8rem] md:text-[0.95rem] font-bold py-1 px-2 md:py-1.5 md:px-3 rounded-lg whitespace-nowrap border ${pillClass}`} data-id="element-158">
                        {pt}
                      </span>;
              })}
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </div>;
}